export class GeolocationService {
    constructor() {
        this.subscriptors = new Set();
        this.lastPosition = undefined;
        this.isWatching = false;
        this.watchId = undefined;
    }
    subscribe(handler) {
        const unsub = () => this.unsubscribe(handler);
        if (this.subscriptors.has(handler)) {
            return unsub;
        }
        this.subscriptors.add(handler);
        handler(this.lastPosition);
        if (this.subscriptors.size === 1) {
            this.startWatch();
        }
        return unsub;
    }
    unsubscribe(handler) {
        if (!this.subscriptors.has(handler)) {
            return;
        }
        this.subscriptors.delete(handler);
        if (this.subscriptors.size === 0) {
            this.stopWatch();
        }
    }
    setPosition(position) {
        this.lastPosition = position;
        for (const sub of this.subscriptors) {
            sub(position);
        }
    }
    startWatch() {
        if (this.isWatching) {
            return;
        }
        this.isWatching = true;
        this.watchId = window.navigator.geolocation.watchPosition(position => this.setPosition(position), error => console.error(error), {
            enableHighAccuracy: true
        });
    }
    stopWatch() {
        if (!this.isWatching) {
            return;
        }
        this.isWatching = false;
        window.navigator.geolocation.clearWatch(this.watchId);
    }
}
